"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelector = exports.useDispatch = exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var context = (0, _react.createContext)();
var useDispatch = (0, _reactRedux.createDispatchHook)(context);
exports.useDispatch = useDispatch;
var useSelector = (0, _reactRedux.createSelectorHook)(context);
exports.useSelector = useSelector;
context.displayName = 'WebChatReduxContext';
var _default = context;
exports.default = _default;